import { $ } from '../lib/dom.js';
import { CONFIG } from '../config.js';

/* Formulario de contacto. */
export function initForm() {
  const form = $('[data-form]');
  if (!form) return;

  const success = $('[data-form-success]');
  const button = $('[data-submit]', form);
  const idleLabel = button ? button.textContent : '';

  if (!CONFIG.contactEndpoint) {
    console.warn(
      '[Plainview] No hay endpoint de contacto (VITE_CONTACT_ENDPOINT / src/config.js): ' +
        'el formulario simula el envío y los mensajes NO se entregan.'
    );
  }

  function setBusy(busy) {
    if (!button) return;
    button.disabled = busy;
    button.textContent = busy ? 'Enviando...' : idleLabel;
  }

  function showError() {
    let box = $('[data-form-error]', form);
    if (!box) {
      box = document.createElement('p');
      box.className = 'pv-form__error';
      box.setAttribute('data-form-error', '');
      box.setAttribute('role', 'alert');
      form.insertBefore(box, button);
    }
    box.textContent = 'No pudimos enviar tu mensaje. Escribinos a contacto@plainview.com.ar.';
  }

  function showSuccess() {
    form.hidden = true;
    if (success) {
      success.hidden = false;
      success.setAttribute('tabindex', '-1');
      success.focus();
    }
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (button && button.disabled) return;
    setBusy(true);

    if (!CONFIG.contactEndpoint) {
      // Comportamiento del template de diseño: 1200 ms y estado "enviado".
      setTimeout(() => {
        setBusy(false);
        showSuccess();
      }, 1200);
      return;
    }

    try {
      const res = await fetch(CONFIG.contactEndpoint, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setBusy(false);
      showSuccess();
    } catch (err) {
      console.error('[Plainview] Falló el envío del formulario:', err);
      setBusy(false);
      showError();
    }
  });
}
